import { createIcon } from "@chakra-ui/react";

const YUSD = createIcon({
  displayName: "YUSD",
  viewBox: "0 0 555 555",
  path: (
    <>
      <g clipPath="url(#clip0_1478_3406)">
        <path
          d="M277.2 555.3C430.514 555.3 554.8 431.014 554.8 277.7C554.8 124.386 430.514 0.100098 277.2 0.100098C123.886 0.100098 -0.399902 124.386 -0.399902 277.7C-0.399902 431.014 123.886 555.3 277.2 555.3Z"
          fill="#006EB8"
        />
        <path
          d="M277.2 537.9C420.905 537.9 537.4 421.405 537.4 277.7C537.4 133.996 420.905 17.5 277.2 17.5C133.496 17.5 17 133.996 17 277.7C17 421.405 133.496 537.9 277.2 537.9Z"
          fill="#6E9FBF"
        />
        <path
          d="M277.2 529.5C416.265 529.5 529 416.765 529 277.7C529 138.635 416.265 25.8999 277.2 25.8999C138.135 25.8999 25.3999 138.635 25.3999 277.7C25.3999 416.765 138.135 529.5 277.2 529.5Z"
          fill="url(#paint0_linear_1478_3406)"
        />
        <path
          d="M277.2 471C383.957 471 470.5 384.457 470.5 277.7C470.5 170.943 383.957 84.3999 277.2 84.3999C170.443 84.3999 83.8999 170.943 83.8999 277.7C83.8999 384.457 170.443 471 277.2 471Z"
          fill="url(#paint1_linear_1478_3406)"
        />
        <path
          d="M279.3 435.6C367.831 435.6 439.6 363.831 439.6 275.3C439.6 186.769 367.831 115 279.3 115C190.769 115 119 186.769 119 275.3C119 363.831 190.769 435.6 279.3 435.6Z"
          stroke="#A26B03"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M277.2 459.2C377.44 459.2 458.7 377.94 458.7 277.7C458.7 177.46 377.44 96.2 277.2 96.2C176.96 96.2 95.7 177.46 95.7 277.7C95.7 377.94 176.96 459.2 277.2 459.2Z"
          fill="#006EB8"
        />
        <path
          d="M277.2 435.6C364.406 435.6 435.1 364.906 435.1 277.7C435.1 190.494 364.406 119.8 277.2 119.8C189.994 119.8 119.3 190.494 119.3 277.7C119.3 364.906 189.994 435.6 277.2 435.6Z"
          fill="url(#paint2_linear_1478_3406)"
        />
        <path d="M329.9 550.1V549.5L329.8 549.6L329.9 550.1Z" fill="#E99400" />
        <path
          d="M182.4 185.8H237.8C250.3 212.6 261.1 242.6 273.5 267.5C284 242 296 209.7 306.2 185.8H360.5C341.3 220.6 318.2 258.3 299 293.1C299 331.9 302.9 367.7 302.9 406.5H252.9C252.9 367.4 253 332.3 253 293.1"
          fill="#006EB8"
        />
        <path
          d="M374.6 186.3C355.4 221.1 332.3 258.8 313.1 293.6C313.1 332.4 317 368.2 317 406.9"
          stroke="#006EB8"
          strokeWidth="4"
          strokeMiterlimit="10"
          fill="transparent"
        />
        <path
          d="M251.5 185.8C264 212.6 274.8 242.6 287.2 267.5"
          stroke="#006EB8"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1478_3406"
          x1="25.3999"
          y1="277.7"
          x2="529"
          y2="277.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBFCFF" />
          <stop offset="0.04" stopColor="#D2F5FC" />
          <stop offset="1" stopColor="#5F91AD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1478_3406"
          x1="83.8999"
          y1="277.7"
          x2="470.5"
          y2="277.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E9FBF" />
          <stop offset="1" stopColor="#006EB8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1478_3406"
          x1="119.3"
          y1="277.7"
          x2="435.1"
          y2="277.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBFCFF" />
          <stop offset="1" stopColor="#5F91AD" />
        </linearGradient>
        <clipPath id="clip0_1478_3406">
          <rect width="555" height="555" fill="white" />
        </clipPath>
      </defs>
    </>
  )
});

export default YUSD;
